var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4398 6.96L13.7865 9.74666C13.2265 12.1533 12.1198 13.1267 10.0398 12.9267C9.70646 12.9 9.34646 12.84 8.95979 12.7467L7.83979 12.48C5.05979 11.82 4.19979 10.4467 4.85313 7.66L5.50646 4.86666C5.63979 4.3 5.79979 3.80666 5.99979 3.4C6.77979 1.78666 8.10646 1.35333 10.3331 1.88L11.4465 2.14C14.2398 2.79333 15.0931 4.17333 14.4398 6.96Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0402 12.9267C9.62689 13.2067 9.10689 13.44 8.47356 13.6467L7.42023 13.9933C4.77356 14.8467 3.38023 14.1333 2.52023 11.4867L1.66689 8.85333C0.813561 6.20666 1.52023 4.80666 4.16689 3.95333L5.22023 3.60666C5.49356 3.51999 5.75356 3.44666 6.00023 3.39999C5.80023 3.80666 5.64023 4.29999 5.50689 4.86666L4.85356 7.65999C4.20023 10.4467 5.06023 11.82 7.84023 12.48L8.96023 12.7467C9.34689 12.84 9.70689 12.9 10.0402 12.9267Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 5.68668L11.6601 6.50668",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77344 8.26666L9.70677 8.76",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.69dc96b5b93cf6345f2a2afa4ae8ff96.svg";
export { ForwardRef as ReactComponent };